import PropTypes from 'prop-types'

import {addPossessive} from '../../../../lib/tools'
import {Accept, Cancel} from '../../../../dashboard/src/components/blocks/Buttons'
import ButtonGroup from '../../../../shared_components/core/buttons/ButtonGroup'
import HowItWorks from './HowItWorks'
import PrivacyNotice from './PrivacyNotice'
import defaultAdvisorAvatar from '../../../../shared_assets/default-advisor-avatar.svg'

const RespondToClientInvite = ({
  accept,
  clientInvite = {},
  decline,
  processingAccept,
  processingDecline,
  returnToController
}) => {
  const {
    advisor = {full_name: '', headshot: null},
    already_accepted: alreadyAccepted = false,
    is_consumer_household_invite: isConsumerHouseholdFlag = false,
    is_household: isHousehold = false,
    other_household_owner: otherHouseholdOwner = {first_name: '', full_name: ''}
  } = clientInvite
  const advisorName = advisor.full_name
  const isConsumerHouseholdInvite = isHousehold && isConsumerHouseholdFlag

  // The other member of a re-added consumer household accepts on behalf of both, so a member
  // following a stale invite link afterwards has nothing left to do:
  if (alreadyAccepted) {
    return (
      <div>
        <h1>Your account is already connected.</h1>
        <div className='invite-overview column-wrapper'>
          <p>
            {
              isConsumerHouseholdInvite || isHousehold ?
                `${otherHouseholdOwner.full_name} accepted this invitation on behalf of your household, so your shared Everplan is already connected to ${advisorName}. There's nothing more for you to do.` :
                'This invitation has already been accepted. There\'s nothing more for you to do.'
            }
          </p>
          <ButtonGroup>
            <Accept onClick={returnToController}>Continue</Accept>
          </ButtonGroup>
        </div>
      </div>
    )
  }

  return (
    <div>
      <h1>Request from {advisorName}</h1>
      <div className='invite-overview column-wrapper'>
        <div className='row-wrapper'>
          {/* Advisors without an avatar (and firms without an organization logo) get the same default avatar used on their contact card. */}
          <img alt='advisor-headshot' className='headshot' src={advisor.headshot || defaultAdvisorAvatar} />
          <div className='column-wrapper'>
            <div className='subheading'>
              {
                isConsumerHouseholdInvite ?
                  `${advisorName} would like to sponsor your Everplans subscription you share with ${otherHouseholdOwner.full_name}.` :
                  `${advisorName} would like to sponsor your subscription on Everplans${isHousehold ? ` and merge your Everplan with ${addPossessive(otherHouseholdOwner.full_name)}.` : '.'}`
              }
            </div>
            <p>
              Connect your account today so that {advisorName} can provide guidance and help as you progress through your planning.
            </p>
          </div>
        </div>
        <ButtonGroup>
          <Cancel onClick={decline} processing={processingDecline}>No, thanks</Cancel>
          <Accept onClick={accept} processing={processingAccept}>Accept invitation</Accept>
        </ButtonGroup>
      </div>
      <div>
        <HowItWorks advisorFullName={advisorName} hasAccepted={false} clientInvite={clientInvite} />
        <PrivacyNotice
          advisorFullName={advisorName}
          isConsumerHouseholdInvite={isConsumerHouseholdInvite}
          isHousehold={isHousehold}
          otherHouseholdOwner={otherHouseholdOwner}
        />
      </div>
    </div>
  )
}

RespondToClientInvite.propTypes = {
  accept: PropTypes.func,
  decline: PropTypes.func,
  clientInvite: PropTypes.shape({
    advisor: PropTypes.shape({
      full_name: PropTypes.string.isRequired,
      headshot: PropTypes.string
    }),
    already_accepted: PropTypes.bool,
    merging_active_plan: PropTypes.bool,
    is_consumer_household_invite: PropTypes.bool,
    is_household: PropTypes.bool.isRequired,
    other_household_owner: PropTypes.shape({
      full_name: PropTypes.string,
      first_name: PropTypes.string
    })
  }),
  processingAccept: PropTypes.bool,
  processingDecline: PropTypes.bool,
  returnToController: PropTypes.func
}

export default RespondToClientInvite
